module.exports = __webpack_public_path__ + "img/foto 2.b2a112f6.jpg";